<template>
    <footer class="footer">
        <div class="container is-fluid">
            <div class="content footer-content between-center">
                <ul class="footer-nav">
                    <li><router-link :to="{ name: 'dashboard' }">Home</router-link></li>&nbsp;|
                    <li><router-link :to="{ name: 'companies.index' }">Contacts</router-link></li>&nbsp;|
                    <li><router-link :to="{ name: 'projects.index' }">Projects</router-link></li>&nbsp;|
                    <li><router-link :to="{ name: 'users.index' }">Users</router-link></li>&nbsp;|
                    <li><router-link :to="{ name: 'tasks.index' }">Tasks</router-link></li>&nbsp;|
                    <li><router-link :to="{ name: 'proposals.index' }">Proposals</router-link></li>&nbsp;|
                    <li><router-link :to="{ name: 'global-settings.index' }">Settings</router-link></li>
                </ul>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
    }
</script>
